const createActionTypes = (base) => ({
	REQUEST: `hospital/${base.toLowerCase()}-request`,
	SUCCESS: `hospital/${base.toLowerCase()}-success`,
	FAILURE: `hospital/${base.toLowerCase()}-failure`,
	RESET: `hospital/${base.toLowerCase()}-reset`,
});

// Google Actions for hospital authentication
export const hospitalGoogleAuthActions = {
	GOOGLE_LOGIN: createActionTypes('google-login'),
	GOOGLE_REGISTER: createActionTypes('google-register'),
};
